<template>
    <div>
        <ais-instant-search :search-store="searchStore" :search-client="client" :index-name="index_name">
            <div @keydown.enter="searchPage()">
                <ais-search-box :class-names="{
                    'ais-SearchBox-input': 'form-control admin-search',
                    'ais-SearchBox-form': 'navbar-form topNavSearch',
                    'ais-SearchBox-submit': 'pull-left',
                  }" v-model="query"></ais-search-box>
            </div>
            <ais-configure :hits-per-page.camel="15" />
            <ais-state-results>
                <template slot-scope="{ query }">
                    <ais-hits v-if="query.length > 0" :class-names="{ 'ais-Hits': 'quick-search-results' }">
                        <div slot="item" slot-scope="{ item }">
                            <search-hit :item="item"/>
                        </div>
                    </ais-hits>
                </template>
            </ais-state-results>
        </ais-instant-search>
    </div>
</template>

<script>
    import SearchHit from "./SearchHit";
    import { createFromAlgoliaCredentials } from 'vue-instantsearch';

    export default {
        name: "new-search",
        components: {SearchHit},
        data() {
            return {
                searchStore: false,
                client: false,
                inst: false,
                query: '',
                results: false,
                index_name: 'company' + window.searchEnv,
            }
        },
        created() {
            this.client = this.$root.client;
            // this.searchStore = createFromAlgoliaCredentials('', '<');
            // this.inst = this.$root.client.initIndex();
        },
        methods: {
            searchPage()
            {
                window.location = '/search?search=' + encodeURI(this.query);
            }
        }
    }
</script>

<style>
    .quick-search-results {
        background: #fff;
        max-height: calc(100vh - 100px);
        overflow-y: scroll;
    }
    ol.ais-Hits-list {
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .ais-SearchBox-submit {
        background: transparent;
        border: none;
        padding: 16px 15px 14px;
    }

    .ais-SearchBox-submit svg {
        width: 12px;
        fill: #b5b6b6;
        height: auto;
    }

    .ais-SearchBox-reset {
        display: none;
    }
</style>